import { Inject, Component } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'cfe-scroll-top',
	templateUrl: './scroll-top.component.html',
	styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent {
	constructor(@Inject(DOCUMENT) private document: Document) {}

	scrollToTop() {
		const elements = document.getElementsByClassName('ng-sidebar__content');
		if (elements) {
			elements.item(0).scrollTop = 0;
		}
	}
}
